import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TDiiaGetStatusResponse,
  TDiiaInitializeProcessingPersonalRequest,
  TDiiaInitializeRequest,
  TDiiaInitializeResponse,
} from '~/store/diia/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const initializeDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaInitializeResponse,
  TDiiaInitializeRequest
>(
  'diia/diiaVerificationProcessingPersonalSubmit',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sharing-initialize`,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getStatusDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaInitializeProcessingPersonalRequest
>(
  'diia/diiaGetStatusVerificationProcessingPersonalSubmit',
  async ({ applicationId, token, requestId }, { rejectWithValue, signal }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sharing-get-status/${requestId}`,
        {
          headers,
          signal,
        }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getFinalStatusDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaInitializeProcessingPersonalRequest
>(
  'diia/diiaGetFinalStatusVerificationProcessingPersonalSubmit',
  async ({ applicationId, token, requestId }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.post(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sharing-get-final-status/${requestId}`,
        null,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

// --------------------

export const revokeInitializeDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaInitializeResponse,
  TDiiaInitializeRequest
>(
  'diia/diiaVerificationProcessingPersonalRevoke',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sharing-initialize`,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeGetStatusDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaInitializeProcessingPersonalRequest
>(
  'diia/diiaGetStatusVerificationProcessingPersonalRevoke',
  async ({ applicationId, token, requestId }, { rejectWithValue, signal }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sharing-get-status/${requestId}`,
        {
          headers,
          signal,
        }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeGetFinalStatusDiiaVerificationProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaInitializeProcessingPersonalRequest
>(
  'diia/diiaGetFinalStatusVerificationProcessingPersonalRevoke',
  async ({ applicationId, token, requestId }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.post(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sharing-get-final-status/${requestId}`,
        null,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
